// Icons
import StoreIcon from "@mui/icons-material/Store";
import HailIcon from "@mui/icons-material/Hail";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import WalletIcon from "@mui/icons-material/Wallet";
import { TypographyCell } from "@/Layouts/components/Tables/DataSmartTable/additional/TypographyCell";
import { RenderCITProps, SpecialRowRenderProps } from "./types";

const iconFontSize = { fontSize: "12px !important" };

function renderRelativeToStoreSection(isRelativeToStore = false) {
	return (
		<>
			{isRelativeToStore ? <StoreIcon sx={{ iconFontSize }} /> : <HailIcon sx={{ iconFontSize }} />}
			{"   "}
			{isRelativeToStore ? "(Relative to Store) " : "(Relative to Self) "}
		</>
	);
}

function renderIconsSection(hasCalendarIcon = -1, hasWalletIcon = false, sections: string[] = []) {
	return (
		<>
			{Boolean(hasCalendarIcon) && <CalendarMonthIcon sx={{ iconFontSize }} />}
			{"   "}
			{Boolean(hasCalendarIcon) && sections[1]}
			{"   "}
			{hasWalletIcon && <WalletIcon sx={{ iconFontSize }} />}
			{"   "}
			{hasWalletIcon && (hasCalendarIcon ? sections[2] : sections[1])}
		</>
	);
}

function RenderCIT(props: Readonly<RenderCITProps>) {
	const { value } = props;
	const isRelativeToStore = value?.includes("Relative to Store");

	const hasCalendarIcon = value?.indexOf("[ICON-CALENDAR]");
	const hasWalletIcon = value?.includes("[ICON-WALLET]");

	const sections = [];
	const tierSplit = value?.split(" ");
	let currentSection = "";

	for (const item of tierSplit ?? []) {
		if (item.startsWith("[ICON-")) {
			sections.push(currentSection);
			currentSection = "";
		} else {
			currentSection += item + " ";
		}
	}

	return (
		<TypographyCell fontSize="14px">
			{renderRelativeToStoreSection(isRelativeToStore)}
			<br />
			{renderIconsSection(hasCalendarIcon, hasWalletIcon, sections)}
		</TypographyCell>
	);
}

export default function SpecialRowRender(props: Readonly<SpecialRowRenderProps>) {
	const { params } = props;
	return <RenderCIT {...params} />;
}
